import React from 'react';
import { Navigate } from 'react-router-dom';

export default function LegacyRmaArchiveRedirect() {
  return <Navigate to="/rma-archive" replace />;
}
